/**
 * React Query keys for workspace integrations (GBP, etc.).
 */
export const integrationsQueryKeys = {
  /** Prefix: all integration caches. */
  root: ['integrations'] as const,
  all: (workspaceId: string | null | undefined) =>
    ['integrations', workspaceId ?? null] as const,
  googleLocations: (workspaceId: string | null | undefined) =>
    ['integrations', 'google', 'locations', workspaceId ?? null] as const,
} as const;
